/// <amd-module name="VSSUI/Components/IdentityCard/GroupMembersCard" />
import * as React from "react";
import * as Resources from "VSSUI/Resources.Persona";

import { format } from "VSS/Core/Util/String";
import { Button } from "VSSUI/Button";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";
import { css } from "VSSUI/Util";
import { Persona } from "../Persona/Persona";
import { PersonaSize } from "../Persona/Persona.Props";
import { IGroupMembersCardProps } from "./ContactCard.Props";

export const GroupMembersCard: React.FunctionComponent<IGroupMembersCardProps> = (props: IGroupMembersCardProps) => {
    const { members, onClickEntity } = props;
    const membersString = format(Resources.IdentityCardMembers, members ? members.length : 0);

    const membersElementList = members
        ? members.map(member => {
              const directReportData = {
                  imageUrl: member.image,
                  primaryText: member.displayName ? member.displayName : "",
                  secondaryText: member.jobTitle ? member.jobTitle : "",
                  tertiaryText: member.department ? member.department : ""
              };

              return (
                  <div className="bolt-identity-card-persona-list-row flex-row flex-grow scroll-hidden" key={member.entityId + member.signInAddress}>
                      <Button
                          className="bolt-identity-card-persona-list-element profile-card-tab-element flex-row flex-grow flex-shrink text-ellipsis"
                          aria-label={member.displayName}
                          onClick={() => {
                              onClickEntity && onClickEntity(member);
                          }}
                          subtle={true}
                      >
                          <Persona size={PersonaSize.size40} identity={member} />
                          <div className="flex-column flex-grow flex-shrink bolt-identity-card-name scroll-hidden">
                              <div className="text-left text-ellipsis">{directReportData.primaryText}</div>
                              {directReportData.secondaryText === "" ? (
                                  undefined
                              ) : (
                                  <div className="text-left text-ellipsis">{directReportData.secondaryText}</div>
                              )}
                          </div>
                      </Button>
                  </div>
              );
          })
        : [];

    return (
        <div className="bolt-identity-contact-card-organization-card-wrapper bolt-identity-card-content">
            <div
                className={css(
                    "bolt-identity-organization-card-content v-scroll-auto h-scroll-hidden",
                    membersElementList.length === 0 && "flex-row justify-center"
                )}
            >
                {membersElementList.length > 0 ? (
                    <>
                        <div className="bolt-identity-organization-card-header-wrapper">{membersString} </div>
                        <div className="bolt-identity-organization-card-members-wrapper">{membersElementList}</div>
                    </>
                ) : (
                    <Spinner label={Resources.Loading} size={SpinnerSize.large} className="bolt-identity-card-loading-spinner" />
                )}
            </div>
        </div>
    );
};
